import { render, staticRenderFns } from "./TableOverview.vue?vue&type=template&id=522a1aed&scoped=true"
import script from "./TableOverview.vue?vue&type=script&lang=js"
export * from "./TableOverview.vue?vue&type=script&lang=js"
import style0 from "./TableOverview.vue?vue&type=style&index=0&id=522a1aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a1aed",
  null
  
)

export default component.exports